import start from '../../../../common/microservices/loaders/lazy-microservices/essays'

start(() => import('./render'), 'lazy_microservices__root', {
  lazyStoreManagerLoader: () => import('./lazy-store-manager'),
})
